var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-promotion"},[(_vm.promotion)?_c('promotion-form',{attrs:{"usePromotion":_vm.promotion}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }